import { defineComponent as _defineComponent } from 'vue'
import { RawLocation } from 'vue-router';
import AmountDisplay from '@/app/components/wallets/AmountDisplay.vue';
import { computed, onBeforeMount } from 'vue';
import { useTradeState } from 'ah-trades';
import { useRouter } from 'vue-router/composables';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollateralStatusDashboardWidget',
  props: {
    redirectTo: null
  },
  setup(__props: any) {

const props = __props as {
  redirectTo: RawLocation;
};



const tradeState = useTradeState();

const onBehalfOf = useOnBehalfOf();

const router = useRouter();

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: loadCollaterals,
}).manager;

function loadCollaterals() {
  requestManager.sameOrNewPromise(
    'loadCollaterals',
    () => tradeState.store.useWalletsStore().loadCollaterals({ force: true, clientId: onBehalfOf.value?.id }),
    null
  );
}

onBeforeMount(loadCollaterals);

const collaterals = computed(() => {
  const clientId = onBehalfOf.value
    ? onBehalfOf.value.id
    : tradeState.store.useAuthStore().loggedInIdentity?.client?.id;

  if (clientId) {
    return tradeState.store.useWalletsStore().getCollaterals(clientId);
  }
  return null;
});

function goToCollateral() {
  router.push(props.redirectTo);
}

return { __sfc: true,props, tradeState, onBehalfOf, router, requestManager, loadCollaterals, collaterals, goToCollateral, AmountDisplay }
}

})